import { differenceInDays, isAfter, isBefore, format, isValid } from "date-fns";
var isDateWithinInterval = function (date, min, max) {
    var formattedMinDate = format(min, "MM/dd/yyyy");
    if (isAfter(date, max)) {
        var days = differenceInDays(max, min);
        var errorMessage = "Date should not be more than ".concat(days, " days after ").concat(formattedMinDate);
        return { hasError: true, errorMessage: errorMessage };
    }
    if (isBefore(date, min)) {
        var errorMessage = "Date should not be before ".concat(formattedMinDate);
        return { hasError: true, errorMessage: errorMessage };
    }
    return { hasError: false, errorMessage: "" };
};
var isDateAfterMax = function (date, max) {
    var formattedMaxDate = format(max, "MM/dd/yyyy");
    if (isAfter(date, max)) {
        var errorMessage = "Date should not be after ".concat(formattedMaxDate);
        return { hasError: true, errorMessage: errorMessage };
    }
    return { hasError: false, errorMessage: "" };
};
var isDateBeforeMin = function (date, min) {
    var formattedMinDate = format(min, "MM/dd/yyyy");
    if (isBefore(date, min)) {
        var errorMessage = "Date should not be before ".concat(formattedMinDate);
        return { hasError: true, errorMessage: errorMessage };
    }
    return { hasError: false, errorMessage: "" };
};
var validate = function (date, min, max) {
    if (!date || !isValid(date)) {
        return { hasError: true, errorMessage: "Invalid Date Format" };
    }
    if (min && max) {
        return isDateWithinInterval(date, min, max);
    }
    if (max) {
        return isDateAfterMax(date, max);
    }
    if (min) {
        return isDateBeforeMin(date, min);
    }
    return { hasError: false, errorMessage: "" };
};
export default (function (_a) {
    var date = _a.date, min = _a.min, max = _a.max;
    var validationResult = validate(date, min, max);
    return validationResult;
});
//# sourceMappingURL=useDateValidator.js.map